import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _dec, _class, _class2, _temp;

import React from 'react';
import PropTypes from 'prop-types';
import { locale } from "../../../lib/locale/decorators";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { SpinnerIcon } from "../../../internal/icons/SpinnerIcon";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../Spinner.styles";
import { SpinnerLocaleHelper } from "../locale";
var types = {
  big: 'big',
  mini: 'mini',
  normal: 'normal'
};
export
/**
* DRAFT - инлайн-лоадер
*/
var Spinner = (_dec = locale('Spinner', SpinnerLocaleHelper), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Spinner, _React$Component);

  function Spinner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.theme = void 0;
    _this.locale = void 0;

    _this.renderSpinner = function (type, dimmed) {
      var circleClassName = dimmed ? styles.circleDimmed(_this.theme) : styles.circle(_this.theme);
      return /*#__PURE__*/React.createElement(SpinnerIcon, {
        size: type,
        className: circleClassName,
        dimmed: dimmed
      });
    };

    _this.renderCaption = function (type, caption) {
      return /*#__PURE__*/React.createElement("span", {
        className: cx(styles[type](_this.theme), styles.captionColor(_this.theme))
      }, caption);
    };

    return _this;
  }

  var _proto = Spinner.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    var _this$props = this.props,
        type = _this$props.type,
        _this$props$caption = _this$props.caption,
        caption = _this$props$caption === void 0 ? this.locale.loading : _this$props$caption,
        dimmed = _this$props.dimmed;
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement("div", {
      className: styles.spinner()
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.inner()
    }, this.renderSpinner(type, dimmed)), caption && this.renderCaption(type, caption)));
  };

  return Spinner;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'Spinner', _class2.propTypes = {
  /**
  * Текст рядом с мини-лоадером.
  *
  * 'Загрузка' - значение по-умолчанию
  */
  caption: PropTypes.node,
  dimmed: PropTypes.bool,

  /**
  * Тип спиннера: mini, normal, big
  *
  * Значение по-умолчанию - normal
  *
  * Spinner.types - все доступные типы
  */
  type: PropTypes.oneOf(Object.keys(types))
}, _class2.defaultProps = {
  type: 'normal'
}, _class2.Types = types, _temp)) || _class);